export default function CEProductPreviewer({ selectedProduct, children }) {
  if (!selectedProduct) {
    return <></>;
  }

  return (
    <div className="product-customization__img-container">
      {selectedProduct.images[0] && (
        <img
          className="product-customization__img"
          src={selectedProduct.images[0].url + '?width=1000&height=1000'}
          alt={selectedProduct.title}
          loading="lazy"
        />
      )}
      {children}
    </div>
  );
}
